const buildMapsUrl = (base: string, location: string) =>
	`${base}${encodeURIComponent(location)}`

export const getGoogleMapsDirectionsUrl = (location: string) =>
	buildMapsUrl('https://www.google.com/maps/dir/?api=1&destination=', location)

export const getAppleMapsDirectionsUrl = (location: string) =>
	buildMapsUrl('https://maps.apple.com/?daddr=', location)
